//
// GENERATED by Kilua RPC
//
package rpc

import dev.kilua.rpc.HttpMethod
import dev.kilua.rpc.RpcServiceManager
import dev.kilua.rpc.registerRpcServiceExceptions
import kotlin.Boolean
import kotlin.String
import kotlin.collections.List
import models.Discussion
import models.GameResultSummary
import models.Note
import models.UserSession

object AppServiceManager : RpcServiceManager<AppService>(AppService::class) {
    init {
        registerRpcServiceExceptions()
        bind(AppService::getCurrentUser, HttpMethod.POST, null)
        bind(AppService::getNotes, HttpMethod.POST, null)
        bind(AppService::saveNote, HttpMethod.POST, null)
        bind(AppService::deleteNote, HttpMethod.POST, null)
        bind(AppService::getDiscussions, HttpMethod.POST, null)
        bind(AppService::postDiscussion, HttpMethod.POST, null)
        bind(AppService::getGameHistory, HttpMethod.POST, null)
    }
}
